export const telephoneNumberRegex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
export const TGS_BASE_URL =
  process.env.REACT_APP_URL || "https://www.treasuregames.fun";
export const tawkWidgetId = process.env.REACT_APP_TAWK_WIDGET_ID || "";
export const tawkPropertyId = process.env.REACT_APP_TAWK_PROPERTY_ID || "";
